/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiWarmupSummaryGet200Response,
  WarmupDTO,
} from '../models/index';
import {
    ApiWarmupSummaryGet200ResponseFromJSON,
    ApiWarmupSummaryGet200ResponseToJSON,
    WarmupDTOFromJSON,
    WarmupDTOToJSON,
} from '../models/index';

export interface ApiWarmupPostRequest {
    warmupDTO: WarmupDTO;
}

export interface ApiWarmupSummaryGetRequest {
    yearWeek?: number;
}

/**
 * 
 */
export class WarmupApi extends runtime.BaseAPI {

    /**
     */
    async apiWarmupPostRaw(requestParameters: ApiWarmupPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['warmupDTO'] == null) {
            throw new runtime.RequiredError(
                'warmupDTO',
                'Required parameter "warmupDTO" was null or undefined when calling apiWarmupPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/warmup`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WarmupDTOToJSON(requestParameters['warmupDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiWarmupPost(requestParameters: ApiWarmupPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiWarmupPostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiWarmupSummaryGetRaw(requestParameters: ApiWarmupSummaryGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiWarmupSummaryGet200Response>> {
        const queryParameters: any = {};

        if (requestParameters['yearWeek'] != null) {
            queryParameters['yearWeek'] = requestParameters['yearWeek'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/warmup/summary`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiWarmupSummaryGet200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiWarmupSummaryGet(requestParameters: ApiWarmupSummaryGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiWarmupSummaryGet200Response> {
        const response = await this.apiWarmupSummaryGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
